import './Header.scss';
import Component from './Header.js';
export default Component;